import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RegionItem } from "../../model/calculations/calculation";
import { fluidInput } from "../../model/jetlift/jetlift";

interface State {
    fluidInput: fluidInput | any;
    loading: boolean;
    error: string | null;
    region: string | null,
    regionList: RegionItem[];
    selectedRegion: string | null;
    getSelectedRegion: {};
    fluidViscosityChangeMessage: string;
};

export const initialState: State = {
    fluidInput: {},
    loading: false,
    error: null,
    region: "",
    regionList: [],
    selectedRegion: "",
    getSelectedRegion: {},
    fluidViscosityChangeMessage: "",
};

export const fetchFluidViscosity = createAction("fluidTab/fetchFluidViscosity");
export const fetchBubblepoint = createAction("fluidTab/fetchBubblePoint");

const fluidTabSlice = createSlice({
    name: 'jetlift/fluidTab',
    initialState,
    reducers: {
        resetFluidTab: () => ({
            ...initialState
        }),
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setFluidTabDetails: (state, action) => {
            const payload = action?.payload;
            if (payload) {
                state.fluidInput = {
                    ...payload,
                    hiddenGasIPType: payload?.gasAvailblty === "1" ? payload?.hiddenGasIPType ? payload?.hiddenGasIPType : "0" : "",
                    hiddenOilIPType: payload?.hiddenOilIPType ? payload?.hiddenOilIPType : "0",
                };
            }
        },
        setSpGrWater: (state, action: PayloadAction<number>) => {
            if (state.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    spGrWater: action.payload
                };
            }
        },
        setWaterCut: (state, action: PayloadAction<number>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    waterCut: action.payload
                };
            }
        },
        setBwpd: (state, action: PayloadAction<number>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    bwpd: action.payload
                };
            }
        },
        setOilAPI: (state, action: PayloadAction<number>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    oilAPI: action.payload
                };
            }
        },
        setOilAPI2: (state, action: PayloadAction<number>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    oilAPI: action.payload
                };
            }
        },
        setSpGrOil: (state, action: PayloadAction<number>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    spGrOil: action.payload
                };
            }
        },
        setSpGrOil2: (state, action: PayloadAction<number>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    spGrOil: action.payload
                };
            }
        },
        setOilCut: (state, action: PayloadAction<number>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    oilCut: action.payload
                };
            }
        },
        setBopd: (state, action: PayloadAction<number>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    bopd: action.payload
                };
            }
        },
        setAverageCombinedSpGr: (state, action: PayloadAction<number>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    averageCombinedSpGr: action.payload
                };
            }
        },
        setLiquidPhaseCombinedSpGr: (state, action: PayloadAction<number>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    liquidPhaseCombinedSpGr: action.payload
                };
            }
        },
        setFluidViscosity: (state, action: PayloadAction<number | string>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    fluidViscosity: action?.payload
                };
            }
        },
        setGasProduction: (state, action: PayloadAction<number | string | null>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    gasProduction: action.payload
                };
            }
        },
        setGasProduction2: (state, action: PayloadAction<number | string | null>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    gasProduction: action.payload
                };
            }
        },
        setGOR: (state, action: PayloadAction<number | string | null>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    gor: +(action.payload || 0)
                };
            }
        },
        setGOR2: (state, action: PayloadAction<number | string | null>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    gor: +(action.payload || 0)
                };
            }
        },
        setGLR: (state, action: PayloadAction<number | string | null>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    glr: action.payload
                };
            }
        },
        setGLR2: (state, action: PayloadAction<number | string | null>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    glr: action.payload
                };
            }
        },
        setSpGrGas: (state, action: PayloadAction<number>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    spGrGas: action.payload
                };
            }
        },
        setGasCompressibility: (state, action: PayloadAction<number | string | null>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    gasCompressibility: action.payload
                };
            }
        },
        setBubblePoint: (state, action: PayloadAction<number | string | null>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    bubblePoint: action.payload
                };
            }
        },
        setBottomHoleTemp: (state, action: PayloadAction<number>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    bottomHoleTemp: action.payload
                };
            }
        },
        setSurfaceTemperature: (state, action: PayloadAction<number>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    surfaceTemperature: action.payload
                };
            }
        },
        setOperatingFrequency: (state, action: PayloadAction<number>) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    operatngFreq: action.payload
                }
            }
        },
        setRegion: (state, { payload }) => ({
            ...state,
            region: payload
        }),
        setRegion2: (state, { payload }) => ({
            ...state,
            region: payload
        }),
        setRegionList: (state, { payload }) => ({
            ...state,
            regionList: payload?.map((item: any) => ({ value: item?.id, label: item?.name }))
        }),
        setSelectedRegion: (state, { payload }) => ({
            ...state,
            selectedRegion: payload
        }),
        setGetSelectedRegion: (state, { payload }) => ({
            ...state,
            getSelectedRegion: payload
        }),
        setWaterCutCombinedSpGr: (state, { payload }) => {
            if (state?.fluidInput) {
                const { averageCompositeSpGr, liquidPhaseSpGr, compositeSpGr } = payload ?? "";
                state.fluidInput = {
                    ...state.fluidInput,
                    averageCombinedSpGr: averageCompositeSpGr,
                    liquidPhaseCombinedSpGr: liquidPhaseSpGr,
                    combinedSpGr: compositeSpGr,
                }
            }
        },
        setWaterCtOilCt: (state, { payload }) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    oilCut: payload
                }
            }
        },
        setBopdValues: (state, { payload }) => {
            if (state?.fluidInput) {
                const { bopd, bwpd } = payload ?? "";
                state.fluidInput = {
                    ...state.fluidInput,
                    bopd: bopd,
                    bwpd: bwpd,
                }
            }
        },
        setGasCalValues: (state, { payload }) => {
            if (state?.fluidInput) {
                const { gasProduction, gor, glr } = payload ?? "";
                state.fluidInput = {
                    ...state.fluidInput,
                    gasProduction: gasProduction,
                    gor: gor,
                    glr: glr
                }
            }
        },
        setGasAvailability: (state: any, action: PayloadAction<string>) => {
                state.fluidInput = {
                    ...state.fluidInput,
                    gasAvailblty: action?.payload,
                };
        },
        setHiddenGasIp: (state, action) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    hiddenGasIPType: action.payload,
                };
            }
        },
        setHiddenOilIPType: (state, action) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    hiddenOilIPType: action.payload,
                };
            }
        },
        setHiddenAutoGasCompress: (state, action) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    hdnAutoGasCmpress: action.payload,
                };
            }
        },
        setHiddenBubblePoint: (state, action) => {
            if (state?.fluidInput) {
                state.fluidInput = {
                    ...state.fluidInput,
                    hdnAutoBBlPnt: action.payload,
                };
            }
        },
        setFluidViscosityChangeMessage: (state, action) => {
            state.fluidViscosityChangeMessage = action?.payload || "";
        },
    },
});

export const {
    resetFluidTab,
    setFluidTabDetails,
    setSpGrWater,
    setWaterCut,
    setBwpd,
    setOilAPI,
    setOilAPI2,
    setSpGrOil,
    setSpGrOil2,
    setOilCut,
    setBopd,
    setAverageCombinedSpGr,
    setLiquidPhaseCombinedSpGr,
    setFluidViscosity,
    setGasProduction,
    setGasProduction2,
    setGOR,
    setGOR2,
    setGLR,
    setGLR2,
    setSpGrGas,
    setGasCompressibility,
    setBubblePoint,
    setBottomHoleTemp,
    setSurfaceTemperature,
    setRegion,
    setRegion2,
    setRegionList,
    setSelectedRegion,
    setGetSelectedRegion,
    setWaterCutCombinedSpGr,
    setWaterCtOilCt,
    setBopdValues,
    setGasCalValues,
    setOperatingFrequency,
    setGasAvailability,
    setHiddenGasIp,
    setHiddenAutoGasCompress,
    setHiddenOilIPType,
    setHiddenBubblePoint,
    setFluidViscosityChangeMessage,
} = fluidTabSlice.actions;

export default fluidTabSlice.reducer;